import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { shiftConstant } from "../constants/constants";
class ShiftStore extends EventEmitter {
    constructor() {
        super();
        this.shifts = [];
    }
    getAll() {
        return this.shifts;
    }

    handleAction(action) {
        switch (action.type) {
            case shiftConstant.SHIFT_CREATED: {
                //console.log(this);
                const { shift } = action;
                this.shifts.push(shift);
                this.emit(shiftConstant.SHIFT_CREATED, `SHIFT ${shift.shiftName} created successfully.`);
                this.emit(shiftConstant.SHIFT_STORE_CHANGE);
                break;
            }
            case shiftConstant.SHIFT_CREATION_FAILED: {
                this.emit(shiftConstant.SHIFT_CREATION_FAILED, action.msg);
                break;
            }
            case shiftConstant.FETCHED_ALL_SHIFT: {
                //console.log("inside shift store fetch all", action.data);
                this.shifts = action.data;
                this.emit(shiftConstant.SHIFT_STORE_CHANGE);
                break;
            }
            case shiftConstant.SHIFT_FETCH_FAILED: {
                this.emit(shiftConstant.SHIFT_FETCH_FAILED, action.msg);
                break;
            }
            case shiftConstant.NEW_SHIFT_STARTED: {
                this.emit(shiftConstant.NEW_SHIFT_STARTED, action.msg);
                break;
            }
            case shiftConstant.NEW_SHIFT_FAILED: {
                this.emit(shiftConstant.NEW_SHIFT_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const shiftStore = new ShiftStore();
dispatcher.register(shiftStore.handleAction.bind(shiftStore));
export default shiftStore;


// WEBPACK FOOTER //
// ./src/jsx/store/shift-store.jsx